import React, { forwardRef, useContext } from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
// import moment, { Moment } from 'moment';
// import 'moment/locale/ru';
import 'dayjs/locale/ru';
import locale from 'antd/es/date-picker/locale/ru_RU';
import styled from 'styled-components';
import { colorsPalette } from '../../styles/colors-palette';
import { ValidationContext } from './Validation';
import { Skeleton } from './Skeleton';

const DATE_FORMAT = 'DD.MM.YYYY';
type DateRangeSizeType = 'large' | 'middle' | 'small';

//TODO: add locale param on demand
interface DateRangePickerProps {
  placeholder?: [string, string];
  value?: [Date | null, Date | null];
  disabled?: boolean;
  size?: DateRangeSizeType;
  onChange?: (dates: RangeValue) => void;
  loading?: boolean;
  className?: string;
  customStyles?: { width: CSSSize };
  testIds?: { from?: string; to?: string };
}

const { RangePicker: AntRangePicker } = AntDatePicker;

type RangeValue = [Date | null, Date | null] | null;
type AntRangeValue = [Dayjs | null, Dayjs | null] | null;

interface InputWithTestIdProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id?: string;
}

const InputWithTestId = forwardRef<HTMLInputElement, InputWithTestIdProps>(function InputWithTestId(
  props,
  ref,
) {
  return <input {...props} ref={ref} data-testid={props.id} />;
});

function DateRangePicker({
  placeholder,
  value,
  disabled,
  size,
  onChange,
  loading,
  className,
  customStyles,
  testIds,
}: DateRangePickerProps): JSX.Element {
  const { validateStatus } = useContext(ValidationContext);
  const antOnChange = (values: AntRangeValue) => {
    if (values !== undefined) {
      if (values === null) {
        onChange && onChange(null);
        return;
      }

      onChange && onChange([values[0]?.toDate() ?? null, values[1]?.toDate() ?? null]);
    }
  };
  let antValue: AntRangeValue = [null, null];

  if (value) {
    antValue = [value[0] ? dayjs(value[0]) : null, value[1] ? dayjs(value[1]) : null];
  }

  if (loading) {
    return <StyledSkeleton className={className} />;
  }

  const hasTestIds = testIds?.from || testIds?.to;

  // TODO add locale param on demand
  return (
    <Styled
      value={antValue}
      size={size ? size : 'large'}
      format={DATE_FORMAT}
      placeholder={placeholder}
      disabled={disabled}
      onChange={antOnChange}
      locale={locale}
      allowClear={false}
      status={validateStatus}
      customstyles={customStyles}
      id={hasTestIds ? { start: testIds?.from, end: testIds?.to } : undefined}
      components={hasTestIds ? { input: InputWithTestId } : undefined}
    />
  );
}

const Styled = styled(AntRangePicker)<{ customstyles }>`
  &.ant-picker {
    width: ${props => props.customstyles?.width || 'auto'};

    :hover {
      border-color: ${colorsPalette.dustyBlue500};
    }
  }

  &.ant-picker-focused {
    border-color: ${colorsPalette.dustyBlue500};
  }
`;

const StyledSkeleton = styled(Skeleton)`
  &.ant-skeleton.ant-skeleton-element .ant-skeleton-input {
    height: 40px;
    vertical-align: middle;
    border-radius: 8px;
  }
`;

export default DateRangePicker;
